import { t } from "@lingui/core/macro";

export const groupSizeLabel = (
  value: number | null | undefined
): string | null => {
  if (value === null || value === undefined || value === 0) {
    return null;
  }

  return value === 1 ? t`1 player` : t`${value} players`;
};
